module.exports = __webpack_public_path__ + "media/images/flags/us-2b96179241e072f75ba926d25fe49309.svg";